// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"623":"939a7230","2371":"c9f208b6","7339":"65d3f076","8579":"0e9ff495","8927":"e9d5fd94"}[chunkId] + ".chunk.css";
};